import classNames from 'classnames';
import './StandardToggle.scss';

interface Props {
  checked: boolean;
  onChange: (e: React.MouseEvent) => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

const StandardToggle = ({
  checked,
  onChange,
  loading,
  disabled,
  className
}: Props) => {
  return (
    <div
      className={classNames('standard-toggle', className, {
        'standard-toggle--active': checked,
        'standard-toggle--loading': loading,
        'standard-toggle--disabled': disabled
      })}
      onClick={!disabled && !loading ? onChange : undefined}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled || loading}
    >
      <div className="standard-toggle__thumb">
        {loading && <span className="standard-toggle__spinner" />}
      </div>
    </div>
  );
};

export default StandardToggle;
